import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true},
  // {path: '/registSupply', component: () => import('@/views/ums/supply/add'), hidden: true},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home'}
    }]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: {title: '商品', icon: 'product'},
    children: [{
      path: 'product',
      name: 'product',
      component: () => import('@/views/pms/product/index'),
      meta: {title: '商品列表', icon: 'product-list'}
    },
      {
        path: 'productDetail',
        name: 'productDetail',
        component: () => import('@/views/pms/product/productDetail'),
        meta: {title: '产品详情'},
        hidden:true
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: {title: '添加商品', icon: 'product-add'}
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: {title: '修改商品', icon: 'product-add'},
        hidden: true
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: {title: '商品分类', icon: 'product-cate'}
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: {title: '添加商品分类'},
        hidden: true
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: {title: '修改商品分类'},
        hidden: true
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: {title: '商品类型', icon: 'product-attr'}
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: {title: '商品属性列表'},
        hidden: true
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: {title: '添加商品属性'},
        hidden: true
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: {title: '修改商品属性'},
        hidden: true
      },
      {
        path: 'brand',
        name: 'brand',
        component: () => import('@/views/pms/brand/index'),
        meta: {title: '品牌管理', icon: 'product-brand'}
      },
      {
        path: 'addBrand',
        name: 'addBrand',
        component: () => import('@/views/pms/brand/add'),
        meta: {title: '添加品牌'},
        hidden: true
      },
      {
        path: 'updateBrand',
        name: 'updateBrand',
        component: () => import('@/views/pms/brand/update'),
        meta: {title: '编辑品牌'},
        hidden: true
      }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      // {
      //   path: 'receiveOrderList',
      //   name: 'receiveOrderList',
      //   component: () => import('@/views/oms/order/receiveOrderList'),
      //   meta: {title: '收货列表'},
      //   hidden:true
      // },
      // {
      //   path: 'signOrderList',
      //   name: 'signOrderList',
      //   component: () => import('@/views/oms/order/signOrderList'),
      //   meta: {title: '签收列表'},
      //   hidden:true
      // },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      },
      {
        path: 'orderBill',
        name: 'orderBill',
        component: () => import('@/views/oms/orderBill/index'),
        meta: {title: '对账单列表'},
        hidden:true
      },
      {
        path: 'addOrderBill',
        name: 'addOrderBill',
        component: () => import('@/views/oms/orderBill/add'),
        meta: {title: '新增对账单'},
        hidden:true
      },
      {
        path: 'updateOrderBill',
        name: 'updateOrderBill',
        component: () => import('@/views/oms/orderBill/update'),
        meta: {title: '发货列表'},
        hidden:true
      }
    ]
  },
  {
    path:'/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: {title: '营销', icon: 'sms'},
    children: [
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: {title: '广告列表', icon: 'sms-ad'}
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: {title: '添加广告'},
        hidden:true
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: {title: '编辑广告'},
        hidden:true
      },
      {
        path: 'alert',
        name: 'alert',
        component: () => import('@/views/sms/alert/index'),
        meta: {title: '消息管理'},
        hidden:true
      }
    ]
  },
  {
    path:'/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {title: '权限', icon: 'ums'},
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {title: '用户列表', icon: 'ums-admin'}
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {title: '角色列表', icon: 'ums-role'}
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {title: '分配菜单'},
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {title: '分配资源'},
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {title: '菜单列表', icon: 'ums-menu'}
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {title: '添加菜单'},
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {title: '修改菜单'},
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {title: '资源列表', icon: 'ums-resource'}
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {title: '资源分类'},
        hidden: true
      }
    ]
  },
  {
    path:'/appms',
    component: Layout,
    redirect: '/appms/member',
    name: 'appms',
    meta: {title: '人员', icon: 'ums'},
    children: [
      {
        path: 'member',
        name: 'member',
        component: () => import('@/views/ums/member/index'),
        meta: {title: '客户', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'sales',
        name: 'sales',
        component: () => import('@/views/ums/member/sales'),
        meta: {title: '业务员', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'master',
        name: 'master',
        component: () => import('@/views/ums/member/master'),
        meta: {title: '销售主管', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'manager',
        name: 'manager',
        component: () => import('@/views/ums/member/manager'),
        meta: {title: '经销商', icon: 'ums-admin'},
        hidden: true
      },
      {
        path: 'suggestionBox',
        name: 'suggestionBox',
        component: () => import('@/views/ums/suggestionBox/index'),
        meta: {title: '反馈意见'}
      },
    ]
  },
  {
    path: '/fms',
    component: Layout,
    redirect: '/fms/orderStatic',
    name: 'fms',
    meta: {title: '财务统计', icon: 'order'},
    children: [
      {
        path: 'orderStatic',
        name: 'orderStatic',
        component: () => import('@/views/fms/orderStatic/index'),
        meta: {title: '订单销售统计'}
      },
      {
        path: 'productStatic',
        name: 'productStatic',
        component: () => import('@/views/fms/productStatic/index'),
        meta: {title: '商品销售额统计', icon: 'sms-ad'}
      },
      {
        path: 'productNum',
        name: 'productNum',
        component: () => import('@/views/fms/productStatic/list'),
        meta: {title: '商品数量统计', icon: 'sms-ad'}
      }
    ]
  },
  {
    path:'/set',
    component: Layout,
    redirect: '/set/orderSetting',
    name: 'set',
    meta: {title: '设置', icon: 'ums'},
    children: [
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'aboutUs',
        name: 'aboutUs',
        component: () => import('@/views/ums/aboutUs/index'),
        meta: {title: '关于我们', icon: 'ums-admin'}
      },
      {
        path: 'finance',
        name: 'finance',
        component: () => import('@/views/ums/finance/index'),
        meta: {title: '我的金融', icon: 'ums-admin'}
      },
      {
        path: 'appAccredit',
        name: 'appAccredit',
        component: () => import('@/views/ums/appAccredit/index'),
        meta: {title: 'app授权协议', icon: 'ums-admin'}
      },
      {
        path: 'payAccount',
        name: 'payAccount',
        component: () => import('@/views/ums/payAccount/index'),
        meta: {title: '账户设置', icon: 'ums-admin'}
      },
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js